import { store } from '@/app/[locale]/_store'

export function getUser() {
  return store.getState().auth.user
}
export function getSettings() {
  return store.getState().settings.data
}
export function getSession() {
  return store.getState().session
}
export function getUTM() {
  return store.getState().utm
}
export function getCurrency() {
  return store.getState().settings?.country?.currency
}
